import axiosClient from '../../../config/api/axios.js'
import { chatCompletionsPath, getChatApiNotConfiguredMessage, isChatApiConfigured } from './config.js'
import { postAetherBackendChatCompletion } from './aetherBackendChat.js'
import { isMissingHermesStream, postHermesStreamCompletion } from './hermesStream.js'
import { parseChatError } from './parseChatError.js'
import { isChatRunPayload, waitForChatRun } from './chatRunPolling.js'
import { normalizeChatCompletionData } from './normalizeChatCompletionData.js'
import { attachmentsUnsupportedResult, resolveChatSourceIds } from './resolveChatSourceIds.js'
import { buildChatCompletionBody } from './buildChatCompletionBody.js'

export async function postChatCompletion({ messages, signal, mode, threadId, files, sourceIds, onStreamEvent }) {
  if (!isChatApiConfigured()) {
    return { ok: false, code: 'NOT_CONFIGURED', message: getChatApiNotConfiguredMessage() }
  }
  const chatPath = chatCompletionsPath()
  const hasAttachments = Array.isArray(files) && files.length > 0
  const explicitSourceIds = Array.isArray(sourceIds) ? sourceIds.filter(Boolean) : []
  if (chatPath === '/api/chat') {
    if (hasAttachments || explicitSourceIds.length > 0) return attachmentsUnsupportedResult()
    return postAetherBackendChatCompletion({ messages, signal, threadId, sourceIds: explicitSourceIds })
  }
  try {
    const sourceResult = await resolveChatSourceIds({ threadId, files, sourceIds, messages, signal })
    if (!sourceResult.ok) return sourceResult
    const body = buildChatCompletionBody({ messages, mode, threadId, sourceIds: sourceResult.sourceIds })
    if (isHermesGoalPath(chatPath)) {
      const streamed = await postHermesStreamCompletion({
        path: chatPath,
        body,
        signal,
        onEvent: onStreamEvent,
      })
      if (!isMissingHermesStream(streamed)) return streamed
    }
    const { data } = await axiosClient.post(chatPath, body, { signal })
    const completionData = isChatRunPayload(data) ? await waitForChatRun(data, signal, { onEvent: onStreamEvent }) : data
    if (completionData?.__chatRunError) {
      return { ok: false, code: 'RUN_FAILED', message: completionData.__chatRunError }
    }
    return normalizeChatCompletionData(completionData)
  } catch (err) {
    return parseChatError(err)
  }
}

function isHermesGoalPath(path) {
  return path === '/api/hermes/goals' || path === '/api/hermes/goals/stream'
}
